import axios from "axios";

const postOnSlack = async (channel: string, message: string) => {
    const url = 'https://slack.com/api/chat.postMessage';
    const TOKEN = `xoxb-1318691374258-1714625649745-GaUuf8TE65qkCJqeIJXkmnkE`;

    try {

        const response = await axios.post(
            url,
            {},
            {
                timeout: 10000,
                transformRequest(data, headers) {
                    delete headers.common['Content-Type'];
                    delete headers.common['Accept'];
                    delete headers.post['Content-Type'];
                    return data;
                },
                params: {
                    token: TOKEN,
                    channel: channel,
                    text: message,
                }
            }
        )

        if ((response as any).data.ok) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.log("Error occured while posting on slack: ", (error as any).message);
        return false;
    }
};

export default postOnSlack;